//import $ from 'jquery';
import CountUp from 'countup.js';


var $dataPointsNums = jQuery( '.js-animate-number' );

var getScrollTop = function() {
	return window.pageYOffset ||
		document.documentElement.scrollTop ||
		document.body.scrollTop ||
		0;
};

$dataPointsNums.each( function( index, element ) {
	var $element = jQuery( element );
	var endVal = parseInt( $element.attr( 'data-number' ), 10 );
	var animEndVal = endVal;
	var cb = function() {};

	if ( endVal > 1000 ) {
		animEndVal = endVal - 100;
	}

	var numAnim = new CountUp( element, 0, animEndVal );

	if ( animEndVal !== endVal ) {
		cb = function() {
			numAnim.update( endVal );
		};
	}

	var animationDone = false;

	var check = function() {
		if ( true === animationDone ) {
			jQuery( window ).off( 'scroll.dataPointsNum.' + index );
			jQuery( window ).off( 'resize.dataPointsNum.' + index );

			return;
		}

		var offset = $element.offset();
		var top = offset.top;
		var scrollTop = getScrollTop();
		var windowHeight = jQuery( window ).height();

		if ( ( top - 100 ) > scrollTop && ( top + 100 ) < ( scrollTop + windowHeight ) ) {
			animationDone = true;
			numAnim.start( cb );
			jQuery( window ).off( 'scroll.dataPointsNum.' + index );
			jQuery( window ).off( 'resize.dataPointsNum.' + index );
		}
	};

	jQuery( window ).on( 'scroll.dataPointsNum.' + index, check );
	jQuery( window ).on( 'resize.dataPointsNum.' + index, check );
	jQuery( check );
} );
